module.exports = "<p-growl [value]=\"msgs\" (onClose)=\"onClose($event)\" [immutable]=\"false\" baseZIndex=\"1030\"></p-growl>\n"